export default __webpack_public_path__ + "static/media/aboutBottomLeft.d8f254f3.png";